import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "../i18n";
import { Section, SectionHeading } from "./Section";
import { IMAGES } from "../data/structure";

export default function GlobalImpact() {
  const { d } = useI18n();
  return (
    <section data-testid="global-impact" className="relative overflow-hidden">
      <img src={IMAGES.skyline} alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-10" />
      <div className="absolute inset-0 bg-jlo-bg/80" />
      <div className="relative z-10">
        <Section>
          <SectionHeading
            kicker={d.impactSection.kicker}
            heading={d.impactSection.heading}
            subtitle={d.impactSection.subtitle}
            align="center"
          />
          <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {d.impactSection.points.map((pt, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: i * 0.05 }}
                data-testid={`impact-point-${i}`}
                className="glass rounded-2xl p-6"
              >
                <div className="font-display text-3xl text-jlo-gold/40 font-bold mb-3">{String(i + 1).padStart(2, "0")}</div>
                <h3 className="font-display text-lg font-semibold text-jlo-warm">{pt.title}</h3>
                <p className="mt-2 text-sm text-jlo-warm/70 leading-relaxed">{pt.body}</p>
              </motion.div>
            ))}
          </div>
        </Section>
      </div>
    </section>
  );
}
